const LOCAL_STORAGE_TYPES = {
    restart: 'restart',
}

export {
    LOCAL_STORAGE_TYPES,
}
